import { connect } from 'react-redux'
// import { getState, getDispatch } from 'x/modules/order/BaseOrderViewConnect'
// import { bindActionCreators } from 'redux'
// import * as StoreActions from 'x/modules//store/StoreState'
import { getSelectedStore, getMySubscription } from 'x/redux/selectors'
import ProductBundlesDetailView from './ProductBundlesDetailView'

export default connect(
  (state) => ({
    // ...getState(state),
    selectedStore: getSelectedStore(state),
    subscription: getMySubscription(state),
  }),
  (dispatch) => ({
    // ...getDispatch(dispatch),
    // syncBackgroundJobs: bindActionCreators(StoreActions.syncBackgroundJobs, dispatch),
  })
)(ProductBundlesDetailView)
